import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MarshalModelFactory } from '@socrates/common';
import { ISimpleTypeCodeEntitiesRepo } from '../interfaces/isimpleTypeCodeEntities.repo';
import { Model } from '@socrates/common';

@Injectable()
export class SimpleTypeCodeEntitiesTestRepo<T extends Model> extends ISimpleTypeCodeEntitiesRepo<T> {
	private _initialized = false;

	constructor() {
		super();
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	initialize(httpClient: HttpClient, restPath: string, inputType: any, modelFactory: MarshalModelFactory<T>) {
		if (!this._initialized) {
			this._initialized = true;
		}
	}

	loadEntities(): Promise<T[]> {
		return Promise.resolve([]);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	getEntity(entityId: string): Promise<T> {
		return Promise.resolve(null);
	}

	get initialized(): boolean {
		return this._initialized;
	}
}
